import axios from 'axios'
import { EMBARCAR_PASSAGEIRO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function embarcarPassageiro (idEmpresa, idReserva) {
  const url = `${URL}/reserva/empresa/${idEmpresa}/reserva/${idReserva}/embarcar-passageiro`;
  return dispatch => axios.post(url,null , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EMBARCAR_PASSAGEIRO,
        payload: response
      })
  );
}
